import {useCallback} from "react";
import {mySongsPageStore,} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";

export interface IFilterArrangementTypeControlsLogic {
  handleResetOnClick: () => void;
}

export const useFilterArrangementTypeControlsLogic = (): IFilterArrangementTypeControlsLogic => {
  const handleResetOnClick = useCallback(() => {
    mySongsPageStore.resetFilterArrangementTypes();
    mySongsPageStore.setFilterFeature('all');
  }, []);

  return {
    handleResetOnClick,
  };
}
